/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import * as Yup from 'yup';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import { styled, useTheme } from '@mui/material/styles';
// _mock
import { useSnackbar } from 'notistack';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import Label from 'src/components/Label';
import AxiosAll from 'src/services/axiosAll';
import { FormProvider, RHFSelect, RHFTextField } from '../../components/hook-form';

// ----------------------------------------------------------------------

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
}));

CreateTaskLabel.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  currentPriority: PropTypes.object,
  isEdit: PropTypes.bool,
  getAllPriorities: PropTypes.func,
};

export default function CreateTaskLabel({ open, onClose, isEdit, currentLabel, getAllLabel }) {
  const theme = useTheme();
  const { userDetails } = useSelector((state) => state.loginReducer);

  const { enqueueSnackbar } = useSnackbar();
  const [color, setColor] = useState('#000'); // Initial color is black

  const handleColorChange = (event) => {
    setColor(event.target.value);
  };

  const NewPrioritySchema = Yup.object().shape({
    name: Yup.string().required('Label is required'),
    color: Yup.string().required('Color is required'),
  });

  const defaultValues = useMemo(
    () => ({
      name: currentLabel?.name || '',
      color: currentLabel?.color || '',
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentLabel]
  );

  const methods = useForm({
    resolver: yupResolver(NewPrioritySchema),
    defaultValues,
  });

  const {
    handleSubmit,
    watch,
    reset,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  useEffect(() => {
    if (isEdit && currentLabel) {
      reset(defaultValues);
    } else {
      reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, currentLabel]);

  const onSubmit = async () => {
    try {
      const formData = new FormData();
      formData.append('name', values?.name);
      formData.append('color', values?.color);

      const response = await AxiosAll(
        'post',
        isEdit ? `/labels/${currentLabel?.id}` : '/labels',
        formData,
        userDetails.token
      );

      const { data } = response;

      if (data.statusCode === 201 || data.statusCode === 200) {
        enqueueSnackbar(data?.message, { variant: 'success' });
        onClose();
        getAllLabel();
        reset();
      } else {
        enqueueSnackbar(data?.message, { variant: 'error' });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleRHFTextFieldClick = () => {
    // Trigger the click on the color input when RHFTextField is clicked
    document.getElementById('colorInput').click();
  };
  // console.log(values.color);
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      // onClose={() => {
      //   onClose();
      //   reset(defaultValues);
      // }}
    >
      <DialogTitle>Add New Task Label</DialogTitle>

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={3}>
            <div>
              <LabelStyle>Name</LabelStyle>
              <RHFTextField name="name" placeholder="Task Label Name" />
            </div>
            <div style={{ height: 0, visibility: 'hidden', margin: 0}}>
              <RHFTextField
                type="color"
                id="colorInput"
                name="color"
                value={values?.color}
              />
            </div>

            {values?.name && values?.color && (
              <div>
                <LabelStyle>Preview</LabelStyle>
                <Typography
                  style={{
                    backgroundColor: values?.color || 'transparent',
                    padding: '10px',
                    margin: '10px',
                    color: '#fff',
                    textAlign: 'center',
                    borderRadius: '10px',
                  }}
                >
                  {values?.name}
                </Typography>
              </div>
            )}

            <div onClick={handleRHFTextFieldClick}>
              <LabelStyle>Color</LabelStyle>
              <RHFTextField name="color" value={values?.color} />
            </div>
          </Stack>
        </DialogContent>

        <Divider />

        <DialogActions>
          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            {isEdit ? 'Update' : 'Create'}
          </LoadingButton>
          <Button
            color="inherit"
            variant="outlined"
            onClick={() => {
              onClose();
              reset(defaultValues);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
